import { useMutation, useQuery } from "react-query";
import {
    _api_get_departure,
    _api_get_notice_period,
    _api_post_step_departure,
} from "../api";
import { useForm } from "react-hook-form";
import moment from "moment";
import {
    func_format_data_notice_period,
    onSubmit,
} from "../utils/func.departure";
import { RULES_DEPARTURE } from "../constants/rules.departure";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constants/routes";
import { useSetStep } from "../stores/useStepNumber";
import { useUserOffboarding } from "./useUserOffboarding";

const useLogicStepDeparture = () => {
    // * CONSTANTS
    const QUERY_KEY = "DEPARTURE";

    // * HOOKS
    const navigate = useNavigate();
    const location = useLocation();

    const { user_offboarding, setUserOffboarding } = useUserOffboarding(
        (state) => state
    );

    useSetStep(1); // on est a la 1ere étape

    // * FORMS
    const {
        control,
        register,
        formState: { errors, isValid },
        handleSubmit,
        setValue,
        getValues,
        watch,
    } = useForm({
        mode: "all",
        defaultValues: {
            notice_period_id: null,
            departure_date: null,
        },
    });

    // * QUERIES & MUTATIONS
    // * QUERIES & MUTATIONS
    // * QUERIES & MUTATIONS
    // get information departure - user & contract
    const {
        data: response,
        isLoading,
        isFetching,
    } = useQuery(
        [QUERY_KEY],
        () => {
            return _api_get_departure({
                id_user: location?.state?.id ?? user_offboarding?.id,
            });
        },
        {
            refetchOnWindowFocus: false,
            onSuccess: (res) => {
                if (res?.contract) {
                    setValue("departure_date", res.contract.departure_date, {
                        shouldDirty: true,
                        shouldTouch: true,
                        shouldValidate: true,
                    });
                    if (res.contract.notice_period?.id) {
                        setValue("notice_period_id", {
                            id: res.contract.notice_period.id,
                            key: res.contract.notice_period.id,
                            header: res.contract.notice_period.name,
                            name: res.contract.notice_period.name,
                        });
                    }
                }
                if (res?.user) {
                    setUserOffboarding({
                        id: res.user.id,
                        key: res.user.id,
                        content: res.user.job_title,
                        email: res.user.email,
                        header: res.user.full_name,
                        image: res.user.avatar,
                    });
                }
                if (res?.success === false) {
                    return navigate(ROUTES.offboarding.home, {
                        state: {
                            visible: true,
                            content: "Not Permitted",
                            level: "danger",
                        },
                    });
                }
                return;
            },
            onError: (error) => {
                return console.log({ error });
            },
        }
    );
    // get list of the durée de préavis
    const { data: list_notice_periods, isLoading: is_loading_notice_period } =
        useQuery(
            [`${QUERY_KEY}::list_notice_period`],
            () => {
                return _api_get_notice_period();
            },
            {
                onSuccess: (data) => {
                    if (data?.length > 0) {
                        const current_period = getValues("notice_period_id");
                        if (!current_period) {
                            return setValue("notice_period_id", {
                                id: data.at(0).id,
                                key: data.at(0).id,
                                header: data.at(0).name,
                                name: data.at(0).name,
                            });
                        }
                    }
                },
            }
        );
    // POST step contract
    const { isLoading: is_loading_mutate, mutate } = useMutation(
        (data) => {
            return _api_post_step_departure(data);
        },
        {
            onSuccess: (data) => {
                if (data?.success) {
                    return navigate(
                        `${ROUTES.offboarding.prepare_offboarding}/justification${location.search}`
                    );
                }
                return alert(data?.message);
            },
        }
    );

    // * RETURN
    return {
        query: {
            data: response,
            isLoading,
            isFetching,
            view: {
                contract: {
                    departure_date: response?.contract?.departure_date
                        ? moment(response?.contract?.departure_date).format(
                              "DD/MM/YYYY"
                          )
                        : null,
                    probationary_period_end_date: response?.contract
                        ?.probationary_period_end_date
                        ? moment(
                              response?.contract?.probationary_period_end_date
                          ).format("DD/MM/YYYY")
                        : null,
                    month_text: moment(response?.contract?.start_date).format(
                        "MMM"
                    ),
                    year: moment(response?.contract?.start_date).format("YYYY"),
                    day_number: moment(response?.contract?.start_date).format(
                        "DD"
                    ),
                    seniority_text:
                        response?.contract?.seniority?.seniority_text,
                    name: response?.contract?.name,
                },
                user: {
                    avatar: response?.user?.avatar,
                    full_name: response?.user?.full_name,
                    job_title: response?.user?.job_title,
                    department: response?.user?.department,
                    agency: response?.user?.agency,
                },
            },
        },
        query_notice_period: {
            data: list_notice_periods,
            isLoading: is_loading_notice_period,
            formated_data: func_format_data_notice_period(list_notice_periods),
        },
        mutation: {
            isLoading: is_loading_mutate,
            mutate_step_contract: mutate,
        },
        form: {
            control,
            register,
            errors,
            handleSubmit,
            onSubmit: (data) =>
                onSubmit(
                    data,
                    mutate,
                    location?.state?.id ?? user_offboarding?.id
                ),
            isValid,
            watch,
            getValues,
            departure: {
                min: moment().format("YYYY-MM-DD"),
            },
            rules: RULES_DEPARTURE,
        },
    };
};

export default useLogicStepDeparture;
